import { useEffect, useRef } from 'react';

import {
  useGroupJobProspectsState,
  useGroupJobProspectsActions
} from './GroupJobProspectsContext';

import {
  getGroupJobProspects,
} from './restApi';

const GroupJobProspectsLoader = () => {
  const groupJobProspectsState = useGroupJobProspectsState();
  const { onResponse, onError } = useGroupJobProspectsActions();
  const hasFetchedRef = useRef(false);
  const authenticityToken = document.querySelector("meta[name='csrf-token']")?.getAttribute("content");

  useEffect(() => {
    if (groupJobProspectsState?.group?.id && groupJobProspectsState?.loading && !hasFetchedRef.current) {
      hasFetchedRef.current = true;
      getGroupJobProspects({
        groupId: groupJobProspectsState.group.id,
        onResponse,
        onError,
        body: {
          authenticityToken,
        },
      });
    }
  }, [groupJobProspectsState?.group?.id, groupJobProspectsState?.loading, onResponse, onError]);

  return null;
};

export default GroupJobProspectsLoader;
